import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";


export function OrganizationLinks() {
  const { data: organizations = [], isLoading } = useQuery({
    queryKey: ['organizations-list'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('organizations')
        .select('id, name, code, is_active')
        .eq('is_active', true)
        .order('name');
      
      if (error) {
        console.error('Error loading organizations:', error);
        throw error;
      }
      
      console.log('Organizations loaded:', data);
      return data;
    },
    staleTime: 60000, // Cache for 1 minute
  });

  console.log('OrganizationLinks - isLoading:', isLoading, 'organizations:', organizations);

  if (isLoading || organizations.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 pt-4 border-t border-border/40">
      <div className="flex items-center justify-center gap-2 mb-3">
        <img src="/NAC_Icon_Only.png" alt="NAC Logo" className="h-4 w-4" />
        <p className="text-sm font-medium text-foreground">
          View flights by airline:
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {organizations.map((org) => (
          <Link
            key={org.id}
            to={`/${org.code.toLowerCase()}`}
            className="text-sm font-medium text-primary hover:text-primary/80 hover:underline transition-colors"
          >
            {org.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
